import { useDispatch, useSelector } from 'react-redux';

import { Pagination } from 'common/components/Table/CommonTableStyles';
import { RootState } from 'common/store/AppStore';
import {
	setQueryFlag,
	setTablePaginationHolder,
} from 'common/store/reducer/commonReducer';

export interface ITableQuery {
	tableQueryObj: {
		pageNumber: number;
		pageSize: number;
	};
	updateTableQuery: (payload: Pagination) => void;
	queryFlag: boolean;
	updateQueryFlag: (val: boolean) => void;
}

export default function useTableQuery(props: {
	id?: string;
	defaultPageSize?: number;
}) {
	const { id: tableId, defaultPageSize } = props;
	const dispatch = useDispatch();

	const defaultQuery = { pageNumber: 0, pageSize: defaultPageSize || 10 };

	const tableQueryObj = useSelector((appState: RootState) => {
		if (tableId) {
			return appState.common.tablePaginationHolder[tableId] || defaultQuery;
		}
		return defaultQuery;
	});

	const updateTableQuery = (payload: Pagination) => {
		if (!tableId) return;
		dispatch(
			setTablePaginationHolder({
				[tableId]: {
					pageNumber: payload.pageNumber,
					pageSize: payload.pageSize,
				},
			}),
		);
	};

	const queryFlag = useSelector(
		(appState: RootState) => appState.common.tableQueryFlag,
	);

	const updateQueryFlag = (val: boolean) => {
		dispatch(setQueryFlag(val));
	};

	return {
		tableQueryObj,
		updateTableQuery,
		queryFlag,
		updateQueryFlag,
	};
}
